<template>
    <div class="searhRidoSelect" v-loading="loading">
        <div class="edit">
            <i v-if="!editIng" class="el-icon-s-tools" @click="editIng=true"></i>
            <i  v-else @click="handlecustomOrRecall" class="el-icon-success"></i>
        </div>

       <ul :class="{'editIng':editIng}">
           <li v-if="editIng || (!editIng&&isServeType)" :class="{'disabled_li':editIng&&!isServeType}" class="cl-f">
               <span>
                   服务类型</span>
               <ul>
                   <li class="item" @click="changeBack('serveType','')"  :class="{'selected':serveType==''}">全部</li>
                   <li  class="item"
                        :class="{'selected':serveType==item.value}"
                        v-for="item in typeList" v-text="item.name"
                        @click="changeBack('serveType',item.value)"></li>
                   <li class="handle" v-if="editIng" >
                       <img @click="useHandle('isServeType')" :src="`${baseUrl}images/`+(isServeType?'eye':'no_eye')+'.png'">
                   </li>
               </ul>
           </li>
           <li v-if="editIng || (!editIng&&isRole)" :class="{'disabled_li':editIng&&!isRole}" class="cl-f">
               <span>
                   服务对象</span>
               <ul>
                   <li class="item" @click="changeBack('roleSelect','')"  :class="{'selected':roleSelect==''}">全部</li>
                   <li  class="item"
                        :class="{'selected':roleSelect==item.value}"
                        v-for="item in roleList" v-text="item.name"
                        @click="changeBack('roleSelect',item.value)"></li>
                   <li class="handle" v-if="editIng" >
                       <img @click="useHandle('isRole')" :src="`${baseUrl}images/`+(isRole?'eye':'no_eye')+'.png'">
                   </li>
               </ul>
           </li>
           <li v-if="editIng || (!editIng&&isSubject)" :class="{'disabled_li':editIng&&!isSubject}" class="cl-f">
               <span>
                   服务主题</span>
               <ul>
                   <li class="item" @click="changeBack('subjectSelect','')"
                       :class="{'selected':subjectSelect==''}">全部</li>
                   <li  class="item" v-for="item in subjectList"
                        :class="{'selected':subjectSelect==item.subId}"
                        v-text="item.subName" @click="changeBack('subjectSelect',item.subId)"></li>
                   <li class="handle" v-if="editIng" >
                       <img @click="useHandle('isSubject')" :src="`${baseUrl}images/`+(isSubject?'eye':'no_eye')+'.png'">
                   </li>
               </ul>
           </li>
           <li v-if="editIng || (!editIng&&isTopic)" :class="{'disabled_li':editIng&&!isTopic}" class="cl-f">
               <span>
                   服务专题</span>
               <ul>
                   <li class="item" @click="changeBack('topicSelect','')"
                       :class="{'selected':topicSelect==''}">全部</li>
                   <li  class="item" v-for="item in topicList" v-text="item.topName"
                        :class="{'selected':topicSelect==item.topId}"
                        @click="changeBack('topicSelect',item.topId)"></li>
                   <li class="handle" v-if="editIng" >
                       <img @click="useHandle('isTopic')" :src="`${baseUrl}images/`+(isTopic?'eye':'no_eye')+'.png'">
                   </li>
               </ul>
           </li>
           <li v-if="editIng || (!editIng&&isDept)" :class="{'disabled_li':editIng&&!isDept}" class="cl-f">
               <span>所属部门</span>
               <ul>
                   <recursion-tab :isFirst="true" v-if="deptList&&deptList.length" :tree="deptList" :isDept="isDept" :dept='deptSelect' @selectDept='selectDept' :editIng="editIng">
                       <li slot="swtch" class="handle" v-if="editIng" >
                           <img @click="useHandle('isDept')" :src="`${baseUrl}images/`+(isDept?'eye':'no_eye')+'.png'">
                       </li>
                   </recursion-tab>
               </ul>

           </li>
       </ul>

    </div>
</template>

<script>
    import recursionTab from '@/components/common/recursionTab.vue'
    import { getCustom,handlecustomOrRecall} from '@/api/serveCenter/serveCenter';
    import { getSubjectVoList,getTopicVoList} from '@/api/serveCenter/serveCenter';
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    export default {
        name: "searhRidoSelect",
        components:{
            recursionTab
        },
        data(){
            return{
                baseUrl: process.env.BASE_URL,
                loading:false,
                editIng:false,
                id:'',
                isRole:false,
                isServeType:false,
                isSubject:false,
                isTopic:false,
                isDept:false,
                roleList:[
                    {
                        name:'教职工',
                        value:'0'
                    },
                    {
                        name:'学生',
                        value:'1'
                    }
                    ],
                typeList: [
                    {
                        name:'查询类',
                        value:'0'
                    },
                    {
                        name:'审批类',
                        value:'1'
                    }
                ],
                subjectList:[],
                topicList:[],
                deptList:[],
                roleSelect:'',
                subjectSelect:'',
                topicSelect:'',
                deptSelect:'',
                serveType: '',

            }
        },
        mounted(){
          this.emitParams();
          this.getCustomFn();
          this.getSubjectVoListFn();
          this.getTopicVoListFn();
          this.getDeptTreeDataFn();
        },
        methods:{
            changeBack(key,val){
                if(this.editIng){
                    return;
                }
                this[key]=val;
                this.emitParams();
            },
            emitParams(){
                let obj={
                    serveType: this.serveType,
                    role_type :this.roleSelect,
                    subject_id :this.subjectSelect,
                    topic_id :this.topicSelect,
                    dept_id :this.deptSelect
                }
                this.$emit('clickEvent',obj)
            },
            // 获取主题查询列表
            getSubjectVoListFn () {
                getSubjectVoList().then(({data})=> {
                    if(data.code == 0){
                        this.subjectList = data.data|| [];
                    }
                }).catch(() => {

                    });
            },
            // 获取专题查询列表
            getTopicVoListFn() {
                getTopicVoList().then(({data})=> {
                    if(data.code == 0){
                        this.topicList = data.data|| []
                    }
                }).catch(() => {
                    });
            },
            getDeptTreeDataFn(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0){
                            this.deptList =  data.data[0].children;
                            // console.log(this.deptList)
                            this.deptList.unshift({id: '', name: "全校"});
                        }else{
                            this.deptList = [{id: '', name: "全校"}];
                        }

                    }
                }).catch(err=>{

                })

            },
            getCustomFn(){
                getCustom().then(({data})=>{
                    if(data.code==0){
                        if(data.data){
                            // console.log(data.data)
                            this.isRole=data.data.isRole;
                            this.isSubject=data.data.isSubject;
                            this.isTopic=data.data.isTopic;
                            this.isDept=data.data.isDept;
                            this.isServeType = true
                            this.id=data.data.id;
                        }else{
                            this.isServeType = true
                            this.isRole=true;
                            this.isSubject=true;
                            this.isTopic=true;
                            this.isDept=true;
                        }

                    }

                }).catch(err=>{

                })
            },
            handlecustomOrRecall(){
                this.loading =true;
                let params={
                    id:this.id,
                    isDept:this.isDept?1:0,
                    isSubject:this.isSubject?1:0,
                    isRole:this.isRole?1:0,
                    isServeType:this.isServeType?1:0,
                    isTopic:this.isTopic?1:0,
                    userId:this.$store.getters.userData.userId

                }
                handlecustomOrRecall(params).then(({data})=>{
                    this.loading =false;
                    if(data.code==0){
                        this.$message.success( "设置搜索项成功！" );

                        this.editIng=false;
                    }else{
                        this.$message.warning( data.msg||"设置搜索项失败！" )
                    }
                }).catch(err=>{
                    this.loading =false;
                    this.$message.error( "服务异常" )

                })
            },
            selectDept(item){
                this.deptSelect= item.id+'';
                this.emitParams();
            },

            useHandle(key){
                console.log(key,'key')
                this[key]=!this[key]

            }
        },
        watch:{
            editIng(){
                this.roleSelect='';
                this.subjectSelect='';
                this.topicSelect='';
                this.deptSelect='';
            }

        }
    }
</script>

<style scoped lang="less">
    .searhRidoSelect{
        padding-top: 10px;
        padding-bottom: 20px;
        >.edit{
            text-align: right;
            padding: 5px 0;
            padding-right: 20px;

            >i{
                color: #2cacf0;
                cursor: pointer;
                font-size: 16px;
                height: 20px;
                &.el-icon-s-tools{
                    opacity: 0.3;
                    &.el-icon-s-tools:hover{
                        opacity: 1;

                    }
                }

            }
            >img{
                width: 20px;
                cursor: pointer;
            }
        }
        >.editIng{
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

            /*background: rgba(232, 242, 250,0.8);*/
            .disabled_li{
                .item{
                    cursor: not-allowed!important;
                    color: #ccc;
                    opacity: 0.7;
                    &.selected{
                        background: rgba(122, 188, 243,0.4)!important;
                    }
                }
            }



        }
        >ul{
            padding: 5px 0;
            width: calc(100% - 40px);
            margin: 0 auto;
            >li{
                width: 100%;
                >span{
                    display:inline-block ;
                    width: 85px;
                    float: left;
                    text-align: right;
                    padding-top: 2px;
                    padding-left: 10px;
                    font-weight: bold;
                    >i{

                        font-size: 12px;
                        font-weight: bold;
                        margin-right: 5px;
                    }
                    >.el-icon-circle-check{
                        color: #97E85F;
                    }
                    >.el-icon-circle-close{
                        color: #D20A0A;
                    }
                }
                >ul{
                    float: left;
                    width: 1000px;
                    >.handle{
                        display: inline-block;
                       >img{
                           width: 20px;
                           padding-top: 5px;
                           cursor: pointer;
                       }

                    }
                    >.item{
                        display: inline-block;
                        padding: 5px 14px;
                        margin: 0 10px;
                        background: #F2F3F6;
                        border-radius: 40px;
                        color: #000;
                        cursor: pointer;
                        min-width: 50px;
                        text-align: center;
                        margin-bottom: 14px;
                        &.selected{
                            background: #48A4EF;
                            cursor: text;
                            color: #fff;
                            font-weight: bold;
                            /*box-shadow: 0 2px 4px rgba(72, 164, 239,0.4), 0 0 6px rgba(72, 164, 239,0.4);*/
                        }
                    }
                }

            }
        }
    }

</style>
